import React from "react";
import outline from "../../assets/icons/home_steps-01.svg";
import calander from "../../assets/animations/calendar (1).json";
import search from "../../assets/animations/search (1).json";
import stethoscope from "../../assets/animations/stethoscope (1).json";
import pills from "../../assets/animations/pills (1).json";
import Lottie from "lottie-react";
const HomeSteps = () => {
  return (
    <div className=" xl:py-28 lg:py-20 md:py-14 py-10 relative">
      <div className="md:top-20 top-32  lg:left-10 left-0 absolute">
        <img src={outline} alt="outline" className="md:w-full w-36" />
      </div>
      <div
        data-aos="fade-up"
        className="xl:w-[1280px] w-11/12 mx-auto flex justify-center items-center flex-col z-10"
      >
        <span className="text-xl font-medium text-[#1d9e75] uppercase border-b border-carob px-2 py-1.5 ">
          Process
        </span>
        <h2 className="lg:text-4xl md:text-3xl text-xl text-center font-bold mt-2 text-matcha leading-tight px-8">
          Simple Steps to Better Health
        </h2>
        <div className="grid xl:grid-cols-4 md:grid-cols-2  md:gap-[3.5rem] gap-10 relative overflow-hidden xl:mt-28 lg:mt-20 md:mt-16 mt-12">
          <div
            style={{
              opacity: 1,
              transform:
                "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
              transformStyle: "preserve-3d",
            }}
            className="flex flex-col justify-start items-center gap-[1.5rem] relative"
          >
            <div className="flex justify-center items-center w-[4.875rem] h-[4.875rem] rounded-[1rem] bg-matcha">
              <div className="w-16 h-16">
                <Lottie animationData={search} loop={true} />
              </div>
            </div>
            <div className="flex flex-col justify-start items-center gap-[0.5em]">
              <div className="text-xl font-bold text-matcha">
                1. Book Online
              </div>
              <p className=" text-base leading-6 text-center text-matcha">
                Choose your specialist and schedule a time that works for you.
              </p>
            </div>
            <div className=" max-w-none md:w-[17.5rem] lg:w-[25rem] xl:max-w-[14.1994rem]  border-[1px] absolute border-dashed border-carob top-[19%] right-[-51%] left-auto bottom-auto"></div>
          </div>
          <div
            style={{
              opacity: 1,
              transform:
                "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
              transformStyle: "preserve-3d",
            }}
            className=" flex flex-col justify-start items-center gap-[1.5rem] relative"
          >
           <div className="flex justify-center items-center w-[4.875rem] h-[4.875rem] rounded-[1rem] bg-matcha">
              <div className="w-16 h-16">
                <Lottie animationData={calander} loop={true} />
              </div>
            </div>
            <div className="flex flex-col justify-start items-center gap-[0.5em]">
              <div className="text-xl font-bold text-matcha">2. Check-In</div>
              <p className=" text-base leading-6 text-center text-matcha">
                Digital registration saves time before you even arrive at the
                clinic.
              </p>
            </div>
            <div className="w-full max-w-[14.1994rem] border-[1px] xl:block hidden absolute border-dashed border-carob top-[19%] right-[-51%] left-auto bottom-auto"></div>
          </div>
          <div
            style={{
              opacity: 1,
              transform:
                "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
              transformStyle: "preserve-3d",
            }}
            className=" flex flex-col justify-start items-center gap-[1.5rem] relative"
          >
            <div className="flex justify-center items-center w-[4.875rem] h-[4.875rem] rounded-[1rem] bg-matcha">
              <div className="w-14 h-14">
                <Lottie animationData={stethoscope} loop={true} />
              </div>
            </div>
            <div className="flex flex-col justify-start items-center gap-[0.5em]">
              <div className="text-xl font-bold text-matcha">
                3. Consultation
              </div>
              <p className=" text-base leading-6 text-center text-matcha">
                Receive expert diagnosis advice from our doctors.
              </p>
            </div>
            <div className=" max-w-none md:w-[17.5rem] lg:w-[25rem] xl:max-w-[14.1994rem]  border-[1px] absolute border-dashed border-carob top-[19%] right-[-51%] left-auto bottom-auto"></div>
          </div>
          <div
            style={{
              opacity: 1,
              transform:
                "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
              transformStyle: "preserve-3d",
            }}
            className=" flex flex-col justify-start items-center gap-[1.5rem] relative"
          >
            <div className="flex justify-center items-center w-[4.875rem] h-[4.875rem] rounded-[1rem] bg-matcha">
              <div className="w-16 h-16">
                <Lottie animationData={pills} loop={true} />
              </div>
            </div>
            <div className="flex flex-col justify-start items-center gap-[0.5em]">
              <div className="text-xl font-bold text-matcha">4. Treatment</div>
              <p className=" text-base leading-6 text-center text-matcha">
                Get your prescription and follow the comprehensive recovery
                plan.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeSteps;
